import { removeRemoteStream, resetCallData } from "../../callback";
import { callLinkToast } from "../../Components/ToastServices/CustomToast";
import callLogs from "../../Components/WebCall/CallLogs/callLog";
import { addShowConfrenceData } from "../../Redux/feature/showConfrenceDataSlice";
import { store } from "../../Redux/store";
import SDK from "../../SDK";
import browserNotify from "../Browser/BrowserNotify";
import { getLocalUserDetails, getUserDetails, initialNameHandle } from "../Chat/User";
import { deleteItemFromLocalStorage, encryptAndStoreInLocalStorage, getFromLocalStorageAndDecrypt } from "../Chat/webChatEncryptDecrypt";
import { getFormatPhoneNumber, getInitialsFromName, getUserIdFromJid } from "../Utility";
import { CALL_RINGING_DURATION, CALL_SESSION_STATUS_CLOSED, CALL_STATUS_CALLING, CALL_STATUS_DISCONNECTED, CALL_STATUS_RINGING, DISCONNECTED_SCREEN_DURATION } from "./Constant";
let callingRemoteStreamRemovalTimer = null;
let missedCallNotificationTimer = null;

export function getCallDuration(timerTime) {
    if (!timerTime) return "";
    let seconds = ("0" + (Math.floor(timerTime / 1000) % 60)).slice(-2);
    let minutes = ("0" + (Math.floor(timerTime / 60000) % 60)).slice(-2);
    let hours = ("0" + Math.floor(timerTime / 3600000)).slice(-2);
    const minAndSecs = `${minutes}:${seconds}`;
    return hours > 0 ? `${hours}:${minAndSecs}` : minAndSecs;
}


export const deleteAndDispatchAction = () => {
    deleteItemFromLocalStorage('roomName')
    deleteItemFromLocalStorage('callType')
    deleteItemFromLocalStorage('call_connection_status')
    encryptAndStoreInLocalStorage("hideCallScreen", false);
    encryptAndStoreInLocalStorage('callingComponent', false)
    encryptAndStoreInLocalStorage("hideCallScreen", false);
    store.dispatch(addShowConfrenceData({
        showComponent: false,
        showCalleComponent: false,
        stopSound: true,
        callStatusText: null
    }));
}

function getFromJidFromRemoteStream(remoteStream) {
    const vcardData = getLocalUserDetails();
    let fromJid = "";
    if (remoteStream.length > 0) {
        remoteStream.map((rs) => {
            let id = rs.fromJid;
            id = id.includes("@") ? id.split("@")[0] : id;
            if (id !== vcardData.fromUser) {
                fromJid = rs.fromJid
            }
        });
    }
    return fromJid;
}

export function updateCallTypeAfterCallSwitch(videoMuted) {
    const {
        getState
    } = store;
    const showConfrenceData = getState().showConfrenceData;
    const {
        data
    } = showConfrenceData;
    let {
        remoteStream,
        localVideoMuted,
        remoteVideoMuted
    } = data || {};
    localVideoMuted = typeof videoMuted != "undefined" ? videoMuted : localVideoMuted;
    const callConnectionStatus = JSON.parse(getFromLocalStorageAndDecrypt('call_connection_status'));
    if (!callConnectionStatus) return;
    let callType = null;
    if (remoteStream && Array.isArray(remoteStream) && remoteStream.length === 2 && callConnectionStatus.callMode === 'onetoone') {
        let fromJid = getFromJidFromRemoteStream(remoteStream);
        if (localVideoMuted && fromJid && remoteVideoMuted[fromJid]) {
            callType = "audio";
        } else {
            callType = "video";
        }
        if (callType && callType !== callConnectionStatus.callType) {
            callConnectionStatus.callType = callType;
            encryptAndStoreInLocalStorage("call_connection_status", JSON.stringify(callConnectionStatus));
            callLogs.update(callConnectionStatus.roomId, {
                callType
            });
        }
    }
}

export const startCallingTimer = () => {
    clearOldCallingTimer();
    callingRemoteStreamRemovalTimer = setTimeout(() => {
        const {
            getState,
            dispatch
        } = store;
        const showConfrenceData = getState().showConfrenceData;
        const {
            data
        } = showConfrenceData;
        if (data.remoteStream) {
            let remoteStreams = [...data.remoteStream];
            let remoteStreamsUpdated = [...data.remoteStream];
            if (remoteStreams) {
                remoteStreams.forEach((stream) => {
                    if (stream.status && (stream.status.toLowerCase() === CALL_STATUS_CALLING || stream.status.toLowerCase() === CALL_STATUS_RINGING)) {
                        removeRemoteStream(stream.fromJid);
                        remoteStreamsUpdated = remoteStreamsUpdated.map((ele) => {
                            if (ele.fromJid !== stream.fromJid) {
                                return ele;
                            } else {
                                return undefined;
                            }
                        }).filter(e => e !== undefined);
                    } else {
                        return undefined;
                    }
                });
                if (remoteStreamsUpdated.length > 1) {
                    dispatch(addShowConfrenceData({
                        ...(data || {}),
                        remoteStream: remoteStreamsUpdated
                    }));
                } else {
                    disconnectCallConnection(remoteStreams);
                }
            }
        }

    }, CALL_RINGING_DURATION)
}

export const clearOldCallingTimer = () => {
    if (callingRemoteStreamRemovalTimer !== null) {
        clearTimeout(callingRemoteStreamRemovalTimer);
        callingRemoteStreamRemovalTimer = null;
    }
}

export const disconnectCallConnection = (remoteStreams = []) => {
    const callConnectionData = JSON.parse(getFromLocalStorageAndDecrypt('call_connection_status'))
    SDK.endCall();
    dispatchDisconnected(CALL_STATUS_DISCONNECTED, remoteStreams);
    callLogs.update(callConnectionData.roomId, {
        "endTime": callLogs.initTime(),
        "sessionStatus": CALL_SESSION_STATUS_CLOSED
    });
    let timeOut = getFromLocalStorageAndDecrypt("isNewCallExist") === true ? 0 : DISCONNECTED_SCREEN_DURATION;
    setTimeout(() => {
        encryptAndStoreInLocalStorage('callingComponent', false)
        deleteItemFromLocalStorage('roomName')
        deleteItemFromLocalStorage('callType')
        deleteItemFromLocalStorage('call_connection_status');
        encryptAndStoreInLocalStorage("hideCallScreen", false);
        resetCallData();
        store.dispatch(addShowConfrenceData({
            showComponent: false,
            showCalleComponent: false,
            callStatusText: null
        }))
        // store.dispatch(resetAudioMute())
    }, timeOut);
}

export function dispatchDisconnected(statusMessage, remoteStreams = []) {
    const {
        getState,
        dispatch
    } = store;
    const showConfrenceData = getState().showConfrenceData;
    const {
        data
    } = showConfrenceData;
    statusMessage = statusMessage || CALL_STATUS_DISCONNECTED;
    dispatch(addShowConfrenceData({
        ...(data || {}),
        callStatusText: statusMessage,
        remoteStream: remoteStreams.length > 1 ? remoteStreams : data.remoteStream,
        stopSound: true
    }))
}

export function resetPinAndLargeVideoUser(fromJid) {
    if (!fromJid) {
        store.dispatch(selectLargeVideoUser());
        store.dispatch(pinUser());
    }
    const state = store.getState();
    const largeVideoUserData = state.largeVideoUserData;
    if (largeVideoUserData.userJid === fromJid) {
        store.dispatch(selectLargeVideoUser());
    }
    // If pinned user disconnected from the call, Need to remove the user.
    const pinUserData = state.pinUserData;
    if (pinUserData.userJid === fromJid) {
        store.dispatch(pinUser(fromJid));
    }
}

export const startMissedCallNotificationTimer = (res) => {
    missedCallNotificationTimer = setTimeout(() => {
        let callConnectionData = JSON.parse(getFromLocalStorageAndDecrypt('call_connection_status'));
        if (callConnectionData) {
            const callDetailObj = callConnectionData ? {
                ...callConnectionData
            } : {};
            callDetailObj['status'] = "ended";
            browserNotify.sendCallNotification(callDetailObj);
        }
    }, CALL_RINGING_DURATION + DISCONNECTED_SCREEN_DURATION)
}

export const clearMissedCallNotificationTimer = () => {
    if (missedCallNotificationTimer !== null) {
        clearTimeout(missedCallNotificationTimer);
        missedCallNotificationTimer = null;
    }
}

export const handleCallParticipantToast = (userJid, type) => {
    const userDetails = getUserDetails(userJid);
    const {
        displayName = getUserIdFromJid(userJid), image = "",thumbImage = "", initialName = ""
    } = userDetails;
    const initial = initialNameHandle(userDetails, initialName);
    callLinkToast(type, displayName, image,thumbImage, initial, "callParticipantList");
};

export const getMaxUsersInCall = () => 8;

export const getCallDisplayDetailsForOnetoManyCall = (userList, type) => {
    let rosterData = {};
    let displayNames = [];
    let displayName = "";
    let vcardData = getLocalUserDetails();
    let participantsData = [];
    if (type !== "subscribe") {
        displayNames.push("You");
        participantsData.push({
            image: vcardData.image,
            thumbImage: vcardData.thumbImage,
            userId: vcardData.fromUser,
            name: vcardData.nickName,
            initialName: getInitialsFromName(vcardData.nickName)
        });
    }
    let currentUserPresentInCall = false;
    userList.map((us) => {
        const phoneNumber = us.includes("@") ? us.split("@")[0] : us;
        if (phoneNumber !== vcardData.fromUser) {
            const roster = {
                ...getUserDetails(phoneNumber)
            };
            if (roster) {
                displayNames.push(roster.displayName);
                participantsData.push({
                    image: roster.image,
                    thumbImage: roster.thumbImage,
                    userId: getUserIdFromJid(us),
                    name: roster.displayName,
                    initialName: roster.initialName
                });   
            } else {
                displayNames.push(getFormatPhoneNumber(phoneNumber));
                participantsData.push({
                    image: "",
                    thumbImage: "",
                    userId: getUserIdFromJid(us),
                    name: "",
                    initialName: ""
                });
            }
        } else {
            currentUserPresentInCall = true;
        }
    });
    let anotherUserslength = userList.length;
    if (currentUserPresentInCall) {
        anotherUserslength = anotherUserslength - 1;
    }
    for (let i = 0; i < displayNames.length; i++) {
        let name = displayNames[i];
        if (displayName) {
            if (i <= 2) {
                if (i < anotherUserslength) {
                    displayName = `${displayName}, ${name}`;
                } else {
                    displayName = `${displayName} and ${name}`;
                }
            } else {
                displayName = `${displayName} and (+${displayNames.length - 3})`;
                break;
            }
        } else {
            displayName = name;
        }
    }
    rosterData.chatType = "groupchat";
    rosterData.displayName = displayName;
    rosterData.participantsData = participantsData;
    return rosterData;
}

export const handleAudioClasses = (volumeVdo = 0) => {
    let volume = volumeVdo == 'NaN' ? 0 : volumeVdo;
    if (volume > 5.5) {
        return "audio_vhigh";
    } else if (volume > 4.5) {
        return "audio_high";
    } else if (volume > 3.5) {
        return "audio_medium";
    } else if (volume > 1.5) {
        return "audio_normal";
    } else if (volume > .5) {
        return "audio_low";
    } else if (volume > 0) {
        return "audio_slient";
    } else {
        return "audio_hidden";
    }
}
